// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyAstce9i61SuUhj1Z1YX9Dd8f8_ooIoHLo",
    authDomain: "firenotes-1867f.firebaseapp.com",
    databaseURL: "https://firenotes-1867f.firebaseio.com",
    projectId: "firenotes-1867f",
    storageBucket: "firenotes-1867f.appspot.com",
    messagingSenderId: "653463931193"
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts